"use client";

import React from "react";
import type { ExportOptions } from "./types";

interface CheckboxRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  title: string;
  description: string;
}

function CheckboxRow({ checked, onChange, title, description }: CheckboxRowProps) {
  return (
    <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-card-50 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 text-blue-600 border-gray-300 dark:border-gray-700 rounded focus:ring-blue-500"
      />
      <div>
        <div className="font-medium text-card-foreground">{title}</div>
        <div className="text-xs text-muted-foreground">{description}</div>
      </div>
    </label>
  );
}

interface ExportOptionsListProps {
  options: ExportOptions;
  selectedItemsCount: number;
  onChange: <K extends keyof ExportOptions>(key: K, value: ExportOptions[K]) => void;
}

export function ExportOptionsList({
  options,
  selectedItemsCount,
  onChange,
}: ExportOptionsListProps) {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Export Options</h3>
      <div className="space-y-3">
        {selectedItemsCount > 0 && (
          <CheckboxRow
            checked={options.includeSelectedOnly}
            onChange={(v) => onChange("includeSelectedOnly", v)}
            title="Export Selected Only"
            description={`Export only ${selectedItemsCount} selected items`}
          />
        )}
        <CheckboxRow
          checked={options.includeFilters}
          onChange={(v) => onChange("includeFilters", v)}
          title="Include Filter Information"
          description="Add applied filters and search terms to the export"
        />
        <CheckboxRow
          checked={options.includeMetadata}
          onChange={(v) => onChange("includeMetadata", v)}
          title="Include Metadata"
          description="Add export date, record count, and other metadata"
        />
      </div>
    </div>
  );
}
